var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContactList',{attrs:{"type":"check-deposit"},on:{"onContactClick":_vm.contactSelectHandler,"newContact":_vm.onNewContact,"back":_vm.drawerBack}})}
var staticRenderFns = []

export { render, staticRenderFns }